import styles from '../styles/skillOrChance.module.scss';

function SkillOrChance() {
  return (
    <div className={styles.skill}>
      <h3>A Backgammon 'Gamble' Pays Off</h3>
      <p>from the September 1982 issue of GAMES Magazine:</p>
      <div>
        <p>
          “Is backgammon a game of skill or chance? Recently, a U.S. court answered that question in a
          decision that will affect backgammon players and promoters throughout the country.
        </p>
        <p>
          The controversy started early in 1981 when police in Portland, Oregon, arrested the well-known
          backgammon tournament director and writer Ted Barr just before the finals of his Portland Marriot
          Open. Because the tournament offered cash prizes and required an entry fee, Barr was charged with
          promoting gambling. According to the statutes of Oregon, New York, and other states, gambling is
          defined as risking something of value upon the outcome of a contest of chance.
        </p>
        <p>
          Instead of coping a plea, Barr decided to fight the charge. He hoped a court would rule again, as
          the Alabama Supreme Court had done in 1976, that backgammon, like chess or bridge, is a game of
          skill. For his defense, Barr enlisted the help of, among others, former World Backgammon Champion
          Paul Magriel, the game's most articulate authority.
        </p>
        <p>
          The main point of the issue was the effect of the dice of the game. \"Even after rolling, you may
          have as many as 30 or more options,\" Magriel told a packed courthouse early this year during his
          two hours of expert testimony. \"The decision where to move your men after the dice have been cast -
          that is the essence of the game. Chance is not a material factor.\"
        </p>
        <p>
          Judge Stephen S. Walker agreed. He found Barr innocent of promoting gambling, concluding that
          “backgammon is not a game of chance but a game of skill.”
        </p>
      </div>
      <div>
        Obviously, we agree completely. If backgammon were strictly a game of chance, players would only be
        expected to win on average just half of their games. Yet stronger players consistently win games
        against \"beginners\". There is so much more to backgammon than just rolling the dice and mindlessly
        racing your men around the board ...
      </div>
    </div>
  );
}

export default SkillOrChance;
